import Schedule from './schedule-view'
export default Schedule
